export default __webpack_public_path__ + "static/purple-splitter-b9321de3c05b9e10db1ac66a4acf34a9.png";